import React from "react";
import { Route, Redirect } from "react-router-dom";
import { PrivateRouteType } from "./types";
import { hasAccess } from "./functions";

const PrivateRoute = ({
  key,
  route,
  path,
  exact,
  logged,
  userRoles,
}: PrivateRouteType) => {
  // const params = useParams();
  const { breadcrumbs, requiredRoles, component: RouteComponent } = route;

  const access = hasAccess(userRoles, requiredRoles);

  return (
    <Route
      key={key}
      path={path}
      exact={exact}
      render={(props) => {
        return logged && access ? (
          <RouteComponent breadcrumbs={breadcrumbs} {...props} />
        ) : logged && !access ? (
          <Redirect to="/access" />
        ) : (
          <Redirect to="/login" />
        );
      }}
    />
  );
};

export default PrivateRoute;
